<script setup lang="ts">
import Header from '@/layouts/header/ColorHeader.vue';
import Footer from '@/layouts/footer/nftFooter.vue';
import Introduction from '@/components/pages/investors/Introduction.vue';
// import History from '@/components/pages/about/History.vue';
import BusinessCulture from '@/components/pages/investors/BusinessCulture.vue';
import TimelineInvestors from "@/components/pages/investors/TimelineInvestors.vue";
import InvestorsNewsletter from '@/components/pages/investors/InvestorsNewsletter.vue';

</script>
<template>
    <Header />
    <Introduction />
    <BusinessCulture />
     <TimelineInvestors/>
    <InvestorsNewsletter />
    <Footer />
    
</template>
